/* unplugin-vue-components disabled */import { render } from "./SvgIconCircleWithPen.vue?vue&type=template&id=26a1074e"
import script from "./SvgIconCircleWithPen.vue?vue&type=script&lang=js"
export * from "./SvgIconCircleWithPen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__